
import { subDays, differenceInDays, addDays } from "date-fns";

export type DatePreset = "7d" | "30d" | "90d";

export function getPresetRange(preset: DatePreset): { start: string; end: string } {
    const now = new Date();
    let start = now;

    switch (preset) {
        case "7d":
            start = subDays(now, 7);
            break;
        case "30d":
            start = subDays(now, 30);
            break;
        case "90d":
            start = subDays(now, 90);
            break;
    }

    return {
        start: start.toISOString(),
        end: now.toISOString(),
    };
}

export function clampRange(startStr: string, endStr: string, maxDays = 365): { start: string; end: string; clamped: boolean } {
    const start = new Date(startStr);
    let end = new Date(endStr);
    let clamped = false;

    if (isNaN(start.getTime()) || isNaN(end.getTime())) {
        throw new Error("Invalid date string provided to clampRange");
    }

    const diff = Math.abs(differenceInDays(end, start));

    if (diff > maxDays) {
        end = addDays(start, maxDays);
        clamped = true;
    }

    return {
        start: start.toISOString(),
        end: end.toISOString(),
        clamped
    };
}
